export let NAVLINK_PREFIX = "Phelma News - ";
export let CATEGORIES_PHELMA_NEWS = "Phelma news";
